import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { imgUrl, track } from "@/lib/api";
import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";

export default function BlogArticle() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [settings, setSettings] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    track("page_view", `/blog/${slug}`);
    api.get("/settings").then((r) => setSettings(r.data));
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="relative min-h-screen bg-[#09090B] text-white">
      <div className="grain" />
      <Navbar settings={settings} />
      <article className="pt-36 pb-24 max-w-3xl mx-auto px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-2 text-yellow-400 text-sm mb-8 hover:gap-3 transition-all">
          <ArrowLeft className="w-4 h-4" /> Retour au blog
        </Link>
        {notFound && <p className="text-zinc-400">Article introuvable.</p>}
        {post && (
          <>
            <h1 data-testid="article-title" className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-6">{post.title}</h1>
            {post.cover_url && <img src={imgUrl(post.cover_url)} alt={post.title} className="w-full rounded-2xl mb-10 border border-white/10" />}
            <div className="prose-invert max-w-none text-zinc-300 leading-relaxed article-content" dangerouslySetInnerHTML={{ __html: post.content }} />
          </>
        )}
      </article>
      <style>{`
        .article-content h2 { font-family:'Roboto',sans-serif; font-weight:900; font-size:1.6rem; color:#fff; margin:2rem 0 0.8rem; }
        .article-content p { margin-bottom:1.1rem; }
      `}</style>
      <Footer settings={settings} />
    </div>
  );
}
